import { OrderRepository } from '../../domain/repositories/OrderRepository';
import { OrderId } from '../../domain/value-objects/OrderId';
import { OrderResponseDto } from '../dtos/OrderDto';

export class GetOrderUseCase {
  constructor(private readonly orderRepository: OrderRepository) {}

  async execute(orderId: string): Promise<OrderResponseDto | null> {
    const orderIdValueObject = OrderId.fromExistingId(orderId);
    const order = await this.orderRepository.findById(orderIdValueObject);

    if (!order) {
      return null;
    }

    const items = order.getItems().map((item) => ({
      variantId: item.getVariantId(),
      productId: item.getProductId().getUniqueIdentifier(),
      sku: item.getSku(),
      productName: item.getProductName(),
      price: item.getPrice().getAmountInDollars(),
      quantity: item.getQuantity(),
      attributes: item.getAttributes(),
      note: item.getNote(),
    }));

    const deliveryInfo = order.getDeliveryInfo();
    const dietaryRequirements = order.getDietaryRequirements();

    return {
      id: order.getId().getUniqueIdentifier(),
      status: order.getStatus(),
      total: order.calculateTotal().getAmountInDollars(),
      itemCount: order.getTotalItemCount(),
      createdAt: order.getCreatedAt().toISOString(),
      items,
      deliveryInfo: {
        fullName: deliveryInfo.fullName,
        phoneNumber: deliveryInfo.phoneNumber.getNormalizedDigits(),
        email: deliveryInfo.email.getEmailAddress(),
        contactMethod: deliveryInfo.contactMethod,
        streetAddress: deliveryInfo.address?.getStreetAddressLine() || null,
        city: deliveryInfo.address?.getCityName() || '',
        state: deliveryInfo.address?.getStateCode() || '',
        zipCode: deliveryInfo.address?.getPostalCode() || '',
        deliveryDate: deliveryInfo.deliveryDate.getTime(),
        deliveryTime: deliveryInfo.deliveryTime,
      },
      dietaryRequirements: {
        vegetarian: dietaryRequirements.vegetarian,
        vegan: dietaryRequirements.vegan,
        glutenFree: dietaryRequirements.glutenFree,
        dairyFree: dietaryRequirements.dairyFree,
        nuts: dietaryRequirements.nuts,
        shellfish: dietaryRequirements.shellfish,
        eggs: dietaryRequirements.eggs,
        soy: dietaryRequirements.soy,
        additionalComments: dietaryRequirements.additionalComments,
      },
      isPaid: order.isPaid(),
      paymentStatus: order.getPaymentStatus(),
    };
  }
}
